// common
export const FETCHING_CHASSIS_AVAILABLE = '@@toyota/FETCHING_CHASSIS_AVAILABLE';
export const FETCHED_CHASSIS_AVAILABLE = '@@toyota/FETCHED_CHASSIS_AVAILABLE';
export const FETCHED_CHASSIS_AVAILABLE_FAILED = '@@toyota/FETCHED_CHASSIS_AVAILABLE_FAILED';
export const FETCHING_COMMENTS_BY_CHASSIS = '@@toyota/FETCHING_COMMENTS_BY_CHASSIS';
export const FETCHED_COMMENTS_BY_CHASSIS = '@@toyota/FETCHED_COMMENTS_BY_CHASSIS';
export const FETCHED_COMMENTS_BY_CHASSIS_FAILED = '@@toyota/FETCHED_COMMENTS_BY_CHASSIS_FAILED';
export const FETCHING_QUALITY_ASSURANCE_ORDER = '@@toyota/FETCHING_QUALITY_ASSURANCE_ORDER';
export const FETCHED_QUALITY_ASSURANCE_ORDER = '@@toyota/FETCHED_QUALITY_ASSURANCE_ORDER';
export const FETCHED_QUALITY_ASSURANCE_ORDER_FAILED = '@@toyota/FETCHED_QUALITY_ASSURANCE_ORDER_FAILED';

// create
export const CREATING_QUALITY_ASSURANCE_ORDER = '@@toyota/CREATING_QUALITY_ASSURANCE_ORDER';
export const CREATED_QUALITY_ASSURANCE_ORDER = '@@toyota/CREATED_QUALITY_ASSURANCE_ORDER';
export const CREATED_QUALITY_ASSURANCE_ORDER_FAILED = '@@toyota/CREATED_QUALITY_ASSURANCE_ORDER_FAILED';

// list
export const FETCHING_QUALITY_ASSURANCE_ORDERS_LIST = '@@toyota/FETCHING_QUALITY_ASSURANCE_ORDERS_LIST';
export const FETCHED_QUALITY_ASSURANCE_ORDERS_LIST = '@@toyota/FETCHED_QUALITY_ASSURANCE_ORDERS_LIST';
export const FETCHED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED = '@@toyota/FETCHED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED';
export const CLOSING_QUALITY_ASSURANCE_ORDER = '@@toyota/CLOSING_QUALITY_ASSURANCE_ORDER';
export const CLOSED_QUALITY_ASSURANCE_ORDER = '@@toyota/CLOSED_QUALITY_ASSURANCE_ORDER';
export const CLOSED_QUALITY_ASSURANCE_ORDER_FAILED = '@@toyota/CLOSED_QUALITY_ASSURANCE_ORDER_FAILED';
export const SET_QA_ORDERS_FILTER = '@@toyota/SET_QA_ORDERS_FILTER';
export const CLEAR_QA_ORDERS_FILTER = '@@toyota/CLEAR_QA_ORDERS_FILTER';
export const EXPORTING_QUALITY_ASSURANCE_ORDERS_LIST = '@@toyota/EXPORTING_QUALITY_ASSURANCE_ORDERS_LIST';
export const EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST = '@@toyota/EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST';
export const EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED = '@@toyota/EXPORTED_QUALITY_ASSURANCE_ORDERS_LIST_FAILED';

// partsAssignment
export const FETCHING_PARTS_AVAILABLE = '@@toyota/FETCHING_PARTS_AVAILABLE';
export const FETCHED_PARTS_AVAILABLE = '@@toyota/FETCHED_PARTS_AVAILABLE';
export const FETCHED_PARTS_AVAILABLE_FAILED = '@@toyota/FETCHED_PARTS_AVAILABLE_FAILED';
export const FETCHING_PARTS_FOR_QUALITY_ASSURANCE_ORDER = '@@toyota/FETCHING_PARTS_FOR_QUALITY_ASSURANCE_ORDER';
export const FETCHED_PARTS_FOR_QUALITY_ASSURANCE_ORDER = '@@toyota/FETCHED_PARTS_FOR_QUALITY_ASSURANCE_ORDER';
export const FETCHED_PARTS_FOR_QUALITY_ASSURANCE_ORDER_FAILED =
  '@@toyota/FETCHED_PARTS_FOR_QUALITY_ASSURANCE_ORDER_FAILED';
export const MANAGING_PART_IN_QUALITY_ASSURANCE_ORDER = '@@toyota/MANAGING_PART_IN_QUALITY_ASSURANCE_ORDER';
export const MANAGED_PART_IN_QUALITY_ASSURANCE_ORDER = '@@toyota/MANAGED_PART_IN_QUALITY_ASSURANCE_ORDER';
export const MANAGED_PART_IN_QUALITY_ASSURANCE_ORDER_FAILED = '@@toyota/MANAGED_PART_IN_QUALITY_ASSURANCE_ORDER_FAILED';

export const ADD_PART_INFO = '@@toyota/ADD_PART_INFO';

// tasksAssignment
export const FETCHING_TASKS_AVAILABLE = '@@toyota/FETCHING_TASKS_AVAILABLE';
export const FETCHED_TASKS_AVAILABLE = '@@toyota/FETCHED_TASKS_AVAILABLE';
export const FETCHED_TASKS_AVAILABLE_FAILED = '@@toyota/FETCHED_TASKS_AVAILABLE_FAILED';
export const FETCHING_PROVIDERS_OUTSOURCED = '@@toyota/FETCHING_PROVIDERS_OUTSOURCED';
export const FETCHED_PROVIDERS_OUTSOURCED = '@@toyota/FETCHED_PROVIDERS_OUTSOURCED';
export const FETCHED_PROVIDERS_OUTSOURCED_FAILED = '@@toyota/FETCHED_PROVIDERS_OUTSOURCED_FAILED';
export const FETCHING_TASKS_BY_QUALITY_ASSURANCE_ORDER = '@@toyota/FETCHING_TASKS_BY_QUALITY_ASSURANCE_ORDER';
export const FETCHED_TASKS_BY_QUALITY_ASSURANCE_ORDER = '@@toyota/FETCHED_TASKS_BY_QUALITY_ASSURANCE_ORDER';
export const FETCHED_TASKS_BY_QUALITY_ASSURANCE_ORDER_FAILED =
  '@@toyota/FETCHED_TASKS_BY_QUALITY_ASSURANCE_ORDER_FAILED';
export const MANAGING_TASK_IN_QUALITY_ASSURANCE_ORDER = '@@toyota/MANAGING_TASK_IN_QUALITY_ASSURANCE_ORDER';
export const MANAGED_TASK_IN_QUALITY_ASSURANCE_ORDER = '@@toyota/MANAGED_TASK_IN_QUALITY_ASSURANCE_ORDER';
export const MANAGED_TASK_IN_QUALITY_ASSURANCE_ORDER_FAILED = '@@toyota/MANAGED_TASK_IN_QUALITY_ASSURANCE_ORDER_FAILED';

export const ADD_TASK_INFO = '@@toyota/ADD_TASK_INFO';
export const ADD_OUTSOURCED_INFO = '@@toyota/ADD_OUTSOURCED_INFO';

export const FETCHING_QUALITY_CONTROL_INVOICING =
  '@@toyota/FETCHING_QUALITY_CONTROL_INVOICING';
export const FETCHED_QUALITY_CONTROL_INVOICING =
  '@@toyota/FETCHED_QUALITY_CONTROL_INVOICING';
export const FETCHED_QUALITY_CONTROL_INVOICING_FAILED = '@@toyota/FETCHED_QUALITY_CONTROL_INVOICING_FAILED';
export const CREATING_QUALITY_CONTROL_INVOICE = '@@toyota/CREATING_QUALITY_CONTROL_INVOICE';
export const CREATED_QUALITY_CONTROL_INVOICE =
  '@@toyota/CREATED_QUALITY_CONTROL_INVOICE';
export const CREATED_QUALITY_CONTROL_INVOICE_FAILED = '@@toyota/CREATED_QUALITY_CONTROL_INVOICE_FAILED';
